import { createStore } from 'satcheljs';
import type ComposeStore from './schema/ComposeStore';

const composeStoreData: ComposeStore = {
    defaultViewState: null,
};

export const getComposeStore = createStore<ComposeStore>('compose', composeStoreData);

const composeStore = getComposeStore();

export default composeStore;
